import { createFileRoute, redirect } from "@tanstack/react-router";

// The landing page moved to /apply. Keep the old public URL working.
export const Route = createFileRoute("/register")({
  beforeLoad: () => {
    throw redirect({ to: "/apply" });
  },
});
